import Cards from "../pages/creditCard/list";
import CardForm from "../pages/creditCard/form";

export default [
  { path: "/cards", component: Cards },
  { path: "/cards/new", component: CardForm },
];
